/**
 * OTA-V2 — board/base image control for superadmin only.
 * Skills and capability packs live on the independent /skills primary.
 * Mount: /ota | /ota/base
 * Operator copy must stay path-free and role-shaped for operators.
 */
import { html, Alert, go } from "./ui.js";
import { OtaSettingsDesk } from "./ota-settings-desk.js";
import { useSession } from "./session.js";
import { confirmLeaveSeat } from "./shell-wayfind.js";
import { ObjectCard, WorkbenchHead, PrepSpine } from "./object-workbench.js";

function leave(from, target) {
  confirmLeaveSeat({ fromRoute: from, targetPath: target });
}

export default function OtaPrimary({ sub, toast }) {
  const { me } = useSession();
  const role = String((me && me.role) || "");
  const caps = (me && me.caps) || [];
  const isSa =
    role === "superadmin" ||
    (Array.isArray(caps) &&
      (caps.includes("sa_full_access") || caps.includes("sa_ota_admin")));
  const here = sub === "base" ? "/ota/base" : "/ota";
  const step = sub === "base" ? "base" : "campaign";

  /* OTA-V2: Admin does not see or open board-image OTA, including typed hashes. */
  if (!isSa) {
    return html`<div className="sheet ota-primary desk-craft house-rack" data-cmc-ota="ota-1" data-cmc-ota2="ota-2" data-cmc-shell="ota-ux">
      <${Alert} tone="bad" title="OTA sealed"
        say="Board image upgrades are visible to platform managers only. Capability packs live in Skills."/>
      <div className="btn-row">
        <button type="button" className="btn btn--go btn--sm" onClick=${() => go("/skills/library")}>Open Skills</button>
        <button type="button" className="btn btn--ghost btn--sm" onClick=${() => leave(here, "/machine")}>Machine list</button>
      </div>
    </div>`;
  }

  return html`<div className="sheet ota-primary desk-craft house-rack obj-wb" data-cmc-ota="ota-1" data-cmc-ota2="ota-2" data-cmc-shell="ota-ux"
      data-cmc-ota-surface="base-only" data-cmc-obj-wb="1091">
    <${WorkbenchHead}
      heading="h1"
      eyebrow="OTA · campaign object"
      title="Board image campaign"
      say="Board firmware, staged images and rollback only. Device capabilities are managed independently in Skills."
      object=${html`<${ObjectCard} kind="Campaign" title="Base image"
        meta="Verify with a device-reported receipt"
        status=${{ on: true, label: "SA seat" }}/>`}
    />
    <${PrepSpine}
      label="OTA preparation"
      activeId=${step}
      onPick=${(id) => go(id === "skills" ? "/skills/library" : "/ota/base")}
      steps=${[
        { id: "campaign", label: "Campaign", say: "Pick base image", done: step === "base" },
        { id: "base", label: "Base", say: "Stage / push", done: false },
        { id: "skills", label: "Skills", say: "Capabilities elsewhere", done: false },
        { id: "verify", label: "Verify", say: "Device report", done: false },
      ]}
    />
    <div className="chips" style=${{ marginBottom: 12, flexWrap: "wrap", gap: 8 }}>
      <button type="button" className="chip" data-tone="go" onClick=${() => go("/ota/base")}>Base image</button>
      <button type="button" className="chip" data-tone="ai" onClick=${() => leave(here, "/skills/library")}>Skills</button>
      <button type="button" className="chip" data-tone="ai"
        onClick=${() => leave(here, "/machine")}>Machine</button>
    </div>
    <${OtaSettingsDesk} toast=${toast}/>
  </div>`;
}
